/** Admin area route path. */
export const ADMIN_PATH = '/admin';

/** Admin sub-routes. */
export const ADMIN_USERS_PATH = `${ADMIN_PATH}/users`;
export const ADMIN_SETTINGS_PATH = `${ADMIN_PATH}/settings`;
export const ADMIN_NOTIFICATIONS_PATH = `${ADMIN_PATH}/notifications`;
export const ADMIN_ADMINS_PATH = `${ADMIN_PATH}/admins`;

/** Page title for admin dashboard (used in header). */
export const ADMIN_PAGE_TITLE = 'Admin';

export interface AdminNavItem {
  path: string;
  label: string;
  description?: string;
  icon: 'dashboard' | 'users' | 'settings' | 'notifications' | 'admins';
}

export const ADMIN_NAV: AdminNavItem[] = [
  { path: ADMIN_PATH, label: 'Dashboard', description: 'Overview', icon: 'dashboard' },
  { path: ADMIN_USERS_PATH, label: 'Users', description: 'Manage accounts', icon: 'users' },
  { path: ADMIN_ADMINS_PATH, label: 'Manage admins', description: 'Grant or revoke admin', icon: 'admins' },
  { path: ADMIN_SETTINGS_PATH, label: 'Settings', description: 'Pricing & config', icon: 'settings' },
  { path: ADMIN_NOTIFICATIONS_PATH, label: 'Notifications', description: 'Send to users', icon: 'notifications' },
];
